/**
 * Copied from https://github.com/indy256/convexhull-js.
 * Adjusted to work with typescript!
 * @author Cristina Constantinescu
 */
interface Point {
    latitude: number;
    longitude: number;
};

export function convexHull<T extends Point>(points: T[]) {
    points.sort(function (a, b) {
        return a.latitude != b.latitude ? a.latitude - b.latitude : a.longitude - b.longitude;
    });

    var n = points.length;
    var hull = [];

    for (var i = 0; i < 2 * n; i++) {
        var j = i < n ? i : 2 * n - 1 - i;
        while (hull.length >= 2 && removeMiddle(hull[hull.length - 2], hull[hull.length - 1], points[j]))
            hull.pop();
        hull.push(points[j]);
    }

    hull.pop();
    return hull;
}

function removeMiddle(a: Point, b: Point, c: Point) {
    var cross = (a.latitude - b.latitude) * (c.longitude - b.longitude) - (a.longitude - b.longitude) * (c.latitude - b.latitude);
    var dot = (a.latitude - b.latitude) * (c.latitude - b.latitude) + (a.longitude - b.longitude) * (c.longitude - b.longitude);
    return cross < 0 || cross == 0 && dot <= 0;
}

